<template>
<nav class="bg-gradient-to-b from-green-50 to-white">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between h-14">
          <div class="flex items-center">
            <router-link to="/"><img src="@/assets/eks.png" alt="MasterBit" class="h-6"></router-link>
          </div>
          
          <!-- Desktop Menu -->
          <div class="hidden md:flex items-center space-x-6">
            <router-link to="/" class="text-gray-900 hover:text-green-500 px-3 py-1.5 text-sm font-medium transition duration-300">Početna</router-link>
            <a href="https://masterbit.eu/#services" class="text-gray-900 hover:text-green-500 px-3 py-1.5 text-sm font-medium transition duration-300">Usluge</a>
            <router-link to="/portfolio" class="text-gray-900 hover:text-green-500 px-3 py-1.5 text-sm font-medium transition duration-300">Portfolio</router-link>
            <router-link to="/about" class="text-gray-900 hover:text-green-500 px-3 py-1.5 text-sm font-medium transition duration-300">O nama</router-link>
            <a href="https://masterbit.eu/#contact" class="bg-green-500 hover:bg-green-600 text-white px-4 py-1.5 rounded-md text-sm font-medium transition duration-300 shadow hover:shadow-green-200">
              Kontaktirajte nas
            </a>
          </div>
          
          <!-- Mobile menu button -->
          <div class="md:hidden flex items-center">
            <button @click="toggleMobileMenu" class="text-gray-500 hover:text-gray-900 focus:outline-none">
              <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>
      
      <!-- Mobile Menu (Dropdown) -->
      <div v-show="isMobileMenuOpen" class="md:hidden bg-white shadow-md">
        <div class="px-2 pt-2 pb-3 space-y-1 sm:px-3">
          <router-link to="/" @click="closeMobileMenu" class="text-gray-900 hover:text-green-500 block px-3 py-2 text-base font-medium">Početna</router-link>
          <a href="https://masterbit.eu/#services" @click="closeMobileMenu" class="text-gray-900 hover:text-green-500 block px-3 py-2 text-base font-medium">Usluge</a>
          <router-link to="/portfolio" @click="closeMobileMenu" class="text-gray-900 hover:text-green-500 block px-3 py-2 text-base font-medium">Portfolio</router-link >
            <router-link to="/about" @click="closeMobileMenu" class="text-gray-900 hover:text-green-500 block px-3 py-2 text-base font-medium">O nama</router-link>
          <a href="https://masterbit.eu/#contact" @click="closeMobileMenu" class="w-full text-left bg-green-500 hover:bg-green-600 text-white px-3 py-2 rounded-md text-base font-medium transition duration-300 shadow hover:shadow-green-200">
            Kontaktirajte nas
          </a>
        </div>
      </div>
    </nav>
    <hr>
  <router-view/>
  
  <!-- Cookie Consent Banner -->
  <!-- <div v-if="showCookieConsent" class="fixed bottom-0 left-0 right-0 bg-white shadow-lg p-4">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between">
      <p class="text-gray-600 text-sm mb-3 sm:mb-0">
        Korištenjem ove web stranice prihvaćate upotrebu kolačića (cookies) u skladu s našom politikom privatnosti.
      </p>
      <button 
        @click="acceptCookies" 
        class="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md text-sm font-medium transition duration-300 shadow hover:shadow-green-200"
      >
        Prihvaćam
      </button>
    </div>
  </div> -->
</template>


<script>
export default {
  data() {
    return {
      isMobileMenuOpen: false,
      showCookieConsent: false
    }
  },

  created() {
    // Check if user has already accepted cookies
    this.showCookieConsent = !localStorage.getItem('cookiesAccepted');
  },

  methods: {
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
    },
    acceptCookies() {
      localStorage.setItem('cookiesAccepted', 'true');
      this.showCookieConsent = false;
    }
  },
  
}
</script>

<style lang="scss">
@media (max-width: 768px) {
  /* Line 47 element styles (adjust as needed) */
  .cookie-consent-banner .element-on-line-47 { /* Replace .cookie-consent-banner .element-on-line-47 with the actual selector */
    width: 100%; /* Example: Make it full width */
    font-size: 14px; /* Example: Reduce font size */
    padding: 10px; /* Example: Adjust padding */
  }
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>


